import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { LogOutIcon, ProfileIcon, stringToColor } from '@guryou/html-components';
import { cognitoLogout, LOGOUT } from '@guryou/redux';
import { getInitials } from '@guryou/utils';
import Avatar from '@material-ui/core/Avatar';

const ProfileMenu = () => {
  const dispatch = useDispatch();
  const [dropDown, setDropDown] = useState(false);
  const history = useHistory();
  const { username, email } = useSelector(state => state.auth.data);
  const localInitials = username && getInitials(username);
  const userColour = username && stringToColor(username);
  const ref = useRef(null);

  const { t } = useTranslation();

  const handleDropDown = useCallback(() => {
    setDropDown(prev => !prev);
  }, []);

  const handleNavigationProfile = () => {
    history.push('/profile');
    handleDropDown();
  };

  const handleLogout = () => {
    dispatch({ type: LOGOUT });
    dispatch(cognitoLogout());
    handleDropDown();
  };

  const handleClickOutside = useCallback(
    event => {
      if (ref.current && !ref.current.contains(event.target)) {
        handleDropDown();
      }
    },
    [handleDropDown] // Add any dependencies here
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <div class="relative">
      <button type="button" onClick={handleDropDown}>
        <Avatar style={{ backgroundColor: userColour }}>{localInitials}</Avatar>
      </button>
      {dropDown && (
        <div ref={ref} class="z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 absolute top-12 right-0">
          <div class="px-4 py-3 text-sm text-gray-900">
            <div>{username}</div>
            <div class="font-medium truncate">{email}</div>
          </div>
          <ul class="py-2 text-sm text-gray-700" aria-labelledby="dropdownDefaultButton">
            <li>
              <button role="link" class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-left w-full" onClick={handleNavigationProfile}>
                <ProfileIcon />
                {t('PROFILE.title')}
              </button>
            </li>
          </ul>
          <div class="py-2">
            <button role="link" class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-left w-full" onClick={handleLogout}>
              <LogOutIcon />
              {t('PROFILE.logout')}
            </button>
          </div>
        </div>
      )}
    </div>
  );

  // return (
  //   <FlexRow xs={5} alignItems="center">
  //     <IconButton label="Settings" onClick={handleClick}>
  //       <Avatar style={{ backgroundColor: userColour }}>{localInitials}</Avatar>
  //     </IconButton>
  //     <MuiMenu
  //       anchorEl={anchorEl}
  //       open={!!anchorEl}
  //       onClose={handleClose}
  //       elevation={0}
  //       getContentAnchorEl={null}
  //       anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  //       transformOrigin={{ vertical: 'top', horizontal: 'right' }}
  //     >
  //       <MuiMenuItem
  //         onClick={() => {
  //           history.push('/profile');
  //           handleClose();
  //         }}
  //       >
  //         <ProfileIcon />
  //         <span className="ml-2">{t('PROFILE.title')}</span>
  //       </MuiMenuItem>
  //       <MuiMenuItem
  //         onClick={() => {
  //           dispatch({ type: LOGOUT });
  //           dispatch(cognitoLogout());
  //           handleClose();
  //         }}
  //       >
  //         <LogOutIcon />
  //         <span className="ml-2">{t('PROFILE.logout')}</span>
  //       </MuiMenuItem>
  //     </MuiMenu>
  //   </FlexRow>
  // );
};

export default ProfileMenu;
